export default {
  methods: {
    showAlert(message, action) {
      bus.$emit('newToastMessage', message, action);
    },

    showErrAlert(error, message ,action) {
      let formatMessage = message;
      const errors = error?.response?.data?.errors;

      if (errors) {
        if (typeof errors === 'string') {
          formatMessage = errors;
        } else if (typeof errors === 'object') {
          const allMessages = [];
          Object.values(errors).forEach(err => {
            if (typeof err === 'string') {
              allMessages.push(err);
            } else if (Array.isArray(err)) {
              allMessages.push(...err);
            }
          });
          message = allMessages.join(', ');
        }
        bus.$emit('newToastMessage', message, action);
        return
      }

      const errorMsg = error?.response?.data?.error;
      if (typeof errorMsg === 'string') {
        formatMessage = errorMsg;
        this.showAlert(formatMessage)
        return
      }

      this.showAlert(message);
    },

    // end
  },
};
